import React from "react";
import { useConfiguration } from "../../hooks";
import { LoadingSpinner } from "./LoadingSpinner";
import { DFXiaomi } from "./Websocket/DFXiaomi";
import { useScript } from "../../hooks/useScript";

export const ConfigurationWrapper = () => {
	const { configurationLoading } = useConfiguration();
	const loaded = useScript({ src: "/scripts/testAgentScript.js" });

	if (configurationLoading || !loaded) {
		return (
			<div className="min-w-full min-h-screen flex items-center justify-center">
				<LoadingSpinner />
			</div>
		);
	}

	return <DFXiaomi />;
};
